
import type {LogEntry} from './../../interfaces/index.js';
export const decodeLogs = (logs: any[]): LogEntry[] => {
  return logs.map((log) => {
    const id = Object.keys(log).find((key) => key !== "data" && key !== "decoded")!;
    const type = log[id];
    const rawData = log.data;
    const decoded = log.decoded.map((item: any) => {
      const decodedObject: any = {};
      for (const key in item) {
        decodedObject[key] = {
          type: item[key].type,
          data: parseData(item[key].type, item[key].data),
        };
      }
      return decodedObject;
    });

    return { id, type, rawData, decoded };
  });
};

export const parseData = (type: string, data: string): string | number | boolean => {
  switch (type) {
    case "u64":
    case "i64":
      return parseInt(data, 10); // Convert to number
    case "bool":
      return data === "true"; // Convert to boolean
    case "publicKey":
      return data; // Leave as string
    default:
      return data; // Default case
  }
};
